import React from 'react'
import PropTypes from 'prop-types'
import $ from 'jquery'

import { attributesNames } from '../../../../constants'
// import { Logger, LoggerTypes } from '../../../../utils'
import { AttributeToolsHeader } from '../../AttributeToolsHeader'
import { AttributeProductDialogCreate } from '../dialogs'
import { AttributeProductCard } from '../AttributeProductCard'

export const AttributeProductPanel = ({
  products,
  currentProject,
  currentScenario,
  terms,
  openDialog,
  setOpenDialog,
  onSearch,
  onAdd,
  onUpdate,
  onImport,
  onDelete,
  onCreate
}) => {
  // Logger.trace(LoggerTypes.CONTAINER, 'AttributeProductPanel.render()', {
  //   currentProject,
  //   currentScenario,
  //   products,
  //   terms
  // })

  const TAB_PANEL_HEIGHT = `${$(window).height() - 265}px`

  return (
    <div className="AttributeProductPanel" style={{ overflow: 'hidden auto', height: TAB_PANEL_HEIGHT }}>
      <AttributeToolsHeader
        currentProject={currentProject}
        currentScenario={currentScenario}
        attributeName={attributesNames.PRODUCTS}
        terms={terms}
        onSearch={onSearch}
        onAdd={onAdd}
        onImport={onImport}
      />
      <div className="attributes-list">
        {products &&
          products.map((product, index) => (
            <AttributeProductCard
              key={`product-${index}`}
              product={product}
              currentProject={currentProject}
              currentScenario={currentScenario}
              actionDispatchDelete={onDelete}
              actionDispatchUpdate={onUpdate}
            />
          ))}
      </div>
      {openDialog && (
        <AttributeProductDialogCreate
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          actionCreateDispatch={onCreate}
          currentProject={currentProject}
          currentScenario={currentScenario}
        />
      )}
    </div>
  )
}

AttributeProductPanel.displayName = 'AttributeProductPanel'

AttributeProductPanel.propTypes = {
  products: PropTypes.array.isRequired,
  currentProject: PropTypes.object.isRequired,
  currentScenario: PropTypes.object,
  openDialog: PropTypes.bool.isRequired,
  setOpenDialog: PropTypes.func.isRequired,
  terms: PropTypes.string.isRequired,
  onSearch: PropTypes.func,
  onAdd: PropTypes.func,
  onUpdate: PropTypes.func,
  onDelete: PropTypes.func,
  onCreate: PropTypes.func,
  onImport: PropTypes.func
}

AttributeProductPanel.defaultProps = {
  products: [],
  currentProject: null,
  currentScenario: null,
  terms: '',
  openDialog: false,
  setOpenDialog: () => {},
  onSearch: null,
  onAdd: null,
  onUpdate: null,
  onDelete: null,
  onCreate: null,
  onImport: null
}
